export default __webpack_public_path__ + "static/screen_info-e255c0d5e579f0243a90a92e82449d20.svg";